import { autoPlacement, offset, useFloating, autoUpdate, useClick, useDismiss, useFocus, useInteractions, useMergeRefs, flip } from '@floating-ui/react';
export function useDropdownBase({
  ref,
  open,
  placement,
  strategy,
  onChange,
  disabled = false,
  middlewares = []
}) {
  const floating = useFloating({
    placement,
    open,
    onOpenChange: onChange,
    whileElementsMounted: autoUpdate,
    strategy,
    middleware: [offset(8), placement ? flip() : autoPlacement({
      allowedPlacements: ['bottom-start', 'bottom-end', 'bottom', 'top-start', 'top-end', 'top']
    }), ...middlewares]
  });
  const click = useClick(floating.context, {
    enabled: !disabled,
    keyboardHandlers: false
  });
  const focus = useFocus(floating.context, {
    enabled: !disabled
  });
  const dismiss = useDismiss(floating.context, {
    enabled: !disabled,
    outsidePressEvent: 'mousedown'
  });
  const {
    getFloatingProps,
    getReferenceProps
  } = useInteractions([click, focus, dismiss]);
  const floatingRef = useMergeRefs([ref, floating.refs.setFloating]);
  const referenceRef = floating.refs.setReference;
  return {
    floatingProps: {
      ref: floatingRef,
      style: floating.context.floatingStyles,
      ...getFloatingProps()
    },
    referenceProps: {
      ref: referenceRef,
      ...getReferenceProps()
    },
    context: floating.context
  };
}